<template>
<el-dialog :title="viewFlag === 'view' ? '查看' :  !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="55%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <el-tabs>
            <el-tab-pane key="1" label="基础信息">
                <div class="des_box">
                    <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                        <!-- <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="werks" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.werks}}</span>
                                <el-input v-else v-model="dataForm.werks" placeholder="工厂" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="工厂名称:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="name2" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.name2}}</span>
                                <el-select v-else v-model="dataForm.name2" filterable clearable placeholder="请选择工厂">
                                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <!-- <el-descriptions-item label="供应商:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="lifnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.lifnr}}</span>
                                <el-input v-else v-model="dataForm.lifnr" placeholder="供应商" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item> -->
                        <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="name1" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.name1}}</span>
                                <el-input v-else v-model="dataForm.name1" placeholder="供应商名称" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料编码:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="matnr" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.matnr}}</span>
                                <el-input v-else v-model="dataForm.matnr" placeholder="物料编码" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="物料描述:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="maktx" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.maktx}}</span>
                                <el-input v-else v-model="dataForm.maktx" placeholder="物料描述" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="单位:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="meins" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.meins}}</span>
                                <el-select v-model="dataForm.meins" filterable clearable placeholder="请选择">
                                    <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="计划期间:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="perxx" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.perxx}}</span>
                                <el-input v-else v-model="dataForm.perxx" placeholder="计划期间" clearable></el-input>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="M+1数量:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zmenge11" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zmenge11}}</span>
                                <ctl-number v-model="dataForm.zmenge11" :min="0" :max="999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="M+2数量:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zmenge22" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zmenge22}}</span>
                                <ctl-number v-model="dataForm.zmenge22" :min="0" :max="999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="M+3数量:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zmenge33" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zmenge33}}</span>
                                <ctl-number v-model="dataForm.zmenge33" :min="0" :max="999999"></ctl-number>
                            </el-form-item>
                        </el-descriptions-item>
                        <el-descriptions-item label="发布日期:" :label-style="getStyle()" :content-style="getStyle2()">
                            <el-form-item prop="zfbrq" style="margin-bottom: 0" size="small">
                                <span v-if="viewFlag === 'view'">{{dataForm.zfbrq}}</span>
                                <el-date-picker v-else v-model="dataForm.zfbrq" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-tab-pane>
            <el-tab-pane :key="2" label="附件文件">
                <!-- TODO:上传下载 产看 需求文档 -->
                <FilesUpDown ref="FilesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
            </el-tab-pane>
        </el-tabs>
    </el-form>
    <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                保存
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getForecastById,
    editForecast,
    createForecast
} from '@/controller/sap'
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
// import{
// } from '@/utils/const'
import moment from 'moment'
import FilesUpDown from "@/views/common/file-up-down";
// require('@/mock/mockContract');
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            FILE_BIZ_TYPE: 7,
            viewData: {
                visible: false,
                width: ''
            },
            factoryList: [],
            unitList: [],
            dataForm: {
                id: '',
                werks: '',
                name2: '',
                lifnr: '',
                name1: '',
                matnr: '',
                maktx: '',
                meins: '',
                perxx: '',
                zmenge11: '',
                zmenge22: '',
                zmenge33: '',
                zfbrq: '',
            },
        }
    },
    components: {
        FilesUpDown, //上传附件
        CtlNumber
    },
    mounted() {},
    methods: {
        init(data, id, viewFlag) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.viewFlag = viewFlag
            this.dataForm.id = id || 0
            this.viewData.visible = true
            this.$nextTick(() => {
                //初始化上传附件
                this.$refs.FilesUpDown.init(this.dataForm.id, this.FILE_BIZ_TYPE, null);
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getForecastById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                        }
                    })
                }
                // 工厂
                this.getFactoryList()
                // 单位
                this.getUnitList()
            })
        },
        // 下拉输入工厂
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        // 单位
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'werks': this.dataForm.werks,
                        'name2': this.dataForm.name2,
                        'lifnr': this.dataForm.lifnr,
                        'name1': this.dataForm.name1,
                        'matnr': this.dataForm.matnr,
                        'maktx': this.dataForm.maktx,
                        'meins': this.dataForm.meins,
                        'perxx': this.dataForm.perxx,
                        'zmenge11': this.dataForm.zmenge11,
                        'zmenge22': this.dataForm.zmenge22,
                        'zmenge33': this.dataForm.zmenge33,
                        'zfbrq': this.dataForm.zfbrq,
                    }
                    if (this.dataForm.id) {
                        editForecast(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createForecast(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 314.4px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
